import { Tab } from "@mui/icons-material";

export const OngletContainerConfig = {
    type: 19,
    label: 'Conteneur d\'onglets',
    icon: Tab,
    allowedBy: [2],
    autoConfig: false,
}